import { render, staticRenderFns } from "./OwnerChargeComponent.vue?vue&type=template&id=8922fe32"
import script from "./OwnerChargeComponent.vue?vue&type=script&lang=js"
export * from "./OwnerChargeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports